module.exports = __webpack_public_path__ + "img/e8e2469e60fa089dd213db356c3b53fc.png";